import { TBetOperator } from '@pturf-betin/betin-models-lib'

export const BET_TYPES = [
    'S', // 'Simple'
    'C', // 'Couplé',
    'CO', // 'Couplé Ordre',
    'COI', // 'Couplé Ordre International',
    'TRU', // 'Trio',
    'TRO', // 'Trio Ordre',
    'TOI', // 'Trio Ordre International',
    '2S4', // '2 sur 4',
    'MIM', // 'Mini Multi',
    'MIR', // 'Mini Multi Régional',
    'MUL', // 'Multi',
    'S4', // 'Super 4',
    'TCE', // 'Tiercé',
    'QTP', // 'Quarté+',
    'QPR', // 'Quarté+ Régional',
    'TOP4', // 'Top 4',
    'TOP5', // 'Top 5',
    'P5', // 'Pick 5',
    'Q5P' // 'Quinté+'
] as const
export type TBetType = (typeof BET_TYPES)[number]

export const BETS_CONFIG: Partial<
    Record<
        TBetType,
        {
            baseCount: number
            minBet: number
            label: string
            types: Record<TFormulaRisk, string> | undefined
            order: boolean
            originBetTypes: Partial<Record<TBetOperator, string[]>>
            operatorLabel?: Partial<Record<TBetOperator, string>>
            operatorMatchingBetType?: Partial<Record<TBetOperator, string>>
        }
    >
> = {
    S: {
        baseCount: 1,
        minBet: 2,
        label: 'Simple',
        types: {
            WIN: 'Gagnant',
            PLACE: 'Placé'
        },
        order: false,
        originBetTypes: {
            GENYBET: ['SIMPLE_GAGNANT', 'SIMPLE_PLACE']
        }
    },
    C: {
        baseCount: 2,
        minBet: 2,
        label: 'Couplé',
        types: {
            WIN: 'Gagnant',
            PLACE: 'Placé'
        },
        order: false,
        originBetTypes: {
            GENYBET: ['COUPLE_GAGNANT', 'COUPLE_PLACE']
        }
    },
    CO: {
        baseCount: 2,
        minBet: 2,
        label: 'Couplé Ordre',
        types: undefined,
        order: true,
        originBetTypes: {
            GENYBET: ['COUPLE_ORDRE']
        }
    },
    TRU: {
        baseCount: 3,
        minBet: 2,
        label: 'Trio',
        types: undefined,
        order: false,
        originBetTypes: {
            GENYBET: ['TRIO']
        },
        operatorMatchingBetType: {
            PMU: 'TR'
        }
    },
    TRO: {
        baseCount: 3,
        minBet: 2,
        label: 'Trio Ordre',
        types: undefined,
        order: true,
        originBetTypes: {
            GENYBET: ['TRIO_ORDRE']
        }
    },
    TCE: {
        baseCount: 3,
        minBet: 1,
        label: 'Tiercé',
        types: undefined,
        order: true,
        originBetTypes: {
            GENYBET: ['TIERCE'] // a confirmer
        },
        operatorMatchingBetType: {
            PMU: 'TI'
        }
    },
    QTP: {
        baseCount: 4,
        minBet: 1.5,
        label: 'Quarté+',
        types: undefined,
        order: true,
        originBetTypes: {
            GENYBET: ['QUARTE_PLUS'] // a confirmer
        },
        operatorMatchingBetType: {
            PMU: 'Q4'
        }
    },
    '2S4': {
        baseCount: 2,
        minBet: 3,
        label: '2 Sur 4',
        types: undefined,
        order: false,
        originBetTypes: {
            GENYBET: ['DEUX_SUR_QUATRE']
        }
    },
    TOP4: {
        baseCount: 4,
        minBet: 2,
        label: 'Top 4',
        types: undefined,
        order: false,
        originBetTypes: {
            GENYBET: ['TOP4']
        }
    },
    S4: {
        baseCount: 4,
        minBet: 1,
        label: 'Top 4 Ordre',
        types: undefined,
        order: true,
        originBetTypes: {
            GENYBET: ['TOP4_ORDRE']
        },
        operatorLabel: {
            PMU: 'Super 4'
        },
        operatorMatchingBetType: {
            PMU: 'SU'
        }
    },
    P5: {
        baseCount: 5,
        minBet: 1,
        label: 'Top 5',
        types: undefined,
        order: false,
        originBetTypes: {
            GENYBET: ['TOP5']
        }
    },
    Q5P: {
        baseCount: 5,
        minBet: 2,
        label: 'Super Top 5',
        types: undefined,
        order: true,
        originBetTypes: {
            GENYBET: ['SUPER_TOP5']
        },
        operatorLabel: {
            PMU: 'Quinté'
        },
        operatorMatchingBetType: {
            PMU: 'Q5'
        }
    }
}

export const FORMULA_RISKS = ['WIN', 'PLACE'] as const
export type TFormulaRisk = (typeof FORMULA_RISKS)[number]

export const FORMULA_KEYS = ['UNIT', 'PART_WHEEL', 'WHEEL'] as const
export type TFormulaKey = (typeof FORMULA_KEYS)[number]

export const FORMULA_KEYS_MAPPER: Partial<
    Record<TBetOperator, Record<TFormulaKey, string>>
> = {
    GENYBET: {
        UNIT: 'C',
        PART_WHEEL: 'PW',
        WHEEL: 'W'
    }
}
